import React, { useRef } from "react";
import localeText from "../../../locale";

const ConfimeaConfirmationUpload = ({
  uploadedFiles,
  onFileUpload,
  onRemoveFile,
  disabled = false,
}) => {
  const fileUploadRef = useRef(null);

  const handleFileSelect = (files) => {
    const filteredFiles = files.filter(
      (file) => file.type === "application/pdf" || file.type.startsWith("image/")
    );
    if (filteredFiles.length > 0) {
      onFileUpload({ files: filteredFiles });
    }
  };

  return (
    <div className="confimea-confirmation-upload">
      <h3>{localeText("uploadYourDocuments")}</h3>
      {uploadedFiles.length > 0 && (
        <div className="confimea-confirmation-uploaded-files">
          <h4>
            {localeText("uploadedFiles")} ({uploadedFiles.length})
          </h4>
          {uploadedFiles.map((file, index) => (
            <div key={index} className="confimea-confirmation-file-item">
              <div
                className="bg-white p-2 confimea-confirmation-file-item-icon"
                style={{ border: "1px solid rgba(224, 224, 224, 1)" }}
              >
                <i className="pi pi-file-pdf text-red-500 text-2xl"></i>
              </div>

              <div className="w-full">
                <div className="flex align-items-center justify-content-between w-full mb-1">
                  <span className="confimea-confirmation-file-name">{file.name}</span>
                  <button
                    type="button"
                    className="p-button p-button-text p-button-sm p-0"
                    style={{
                      color: "#dc2626",
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                    }}
                    title={localeText("removeFile") || "Remover"}
                    onClick={() => onRemoveFile(index)}
                    aria-label={localeText("removeFile") || "Remover"}
                  >
                    <i className="pi pi-times"></i>
                  </button>
                </div>

                <div className="flex align-items-center gap-3">
                  <span className="confimea-confirmation-file-size">
                    {(file.size / 1024 / 1024).toFixed(2)} MB
                  </span>
                  <i className="pi pi-check-circle text-green-500"></i>
                  <span className="confimea-confirmation-file-status">
                    {localeText("ready")}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {!uploadedFiles.length && (
        <div
          className="confimea-confirmation-upload-area"
          style={{
            position: "relative",
            cursor: disabled ? "not-allowed" : "pointer",
          }}
          tabIndex={0}
          onClick={() => {
            if (!disabled) {
              fileUploadRef.current && fileUploadRef.current.click();
            }
          }}
          onKeyDown={(e) => {
            if ((e.key === "Enter" || e.key === " ") && !disabled) {
              fileUploadRef.current && fileUploadRef.current.click();
            }
          }}
          onDragOver={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (disabled) return;
            const files = Array.from(e.dataTransfer.files);
            handleFileSelect(files);
          }}
          aria-disabled={disabled}
          role="button"
        >
          <i className="pi pi-cloud-upload text-6xl text-400"></i>
          <p className="confimea-confirmation-upload-text">
            {localeText("dragFilesHereOrClick")}
          </p>
          <p className="confimea-confirmation-upload-hint">
            {localeText("fileFormatsHint")}
          </p>
          <input
            type="file"
            ref={fileUploadRef}
            name="document"
            style={{
              display: "none",
            }}
            accept="application/pdf,image/*"
            disabled={disabled}
            onChange={(e) => {
              const files = Array.from(e.target.files);
              handleFileSelect(files);
              e.target.value = "";
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ConfimeaConfirmationUpload;

